import { AppState } from 'app/store';

export const getCreditsListLink = (state: AppState) =>
  state.auth.services?.contributions?._links.myContributions;

export const getCreditsList = (state: AppState) =>
  state.contributions.creditsList;

export const getCreditsListNextLink = (state: AppState) =>
  state.contributions._creditListLinks?.next;

export const getCreditsDetails = (state: AppState, creditGuid: string) =>
  (state.contributions?.creditsDetails || {})[creditGuid] || [];
